module.exports = __webpack_public_path__ + "media/no.0b41df77.svg";